import React, { useState } from 'react';
import Heading from '../ui/Heading';
import masterPlanImage from '../../assets/vasudharinihomes_masterplan.jpg';
import FormDetailsPopup from '../ui/ViewFormPopup';

const MasterPlan = () => {
  const [showFormPopup, setShowFormPopup] = useState(false);
  const [showMasterPlanModal, setShowMasterPlanModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Handle master plan click - opens form popup first
  const handleMasterPlanClick = () => {
    setShowFormPopup(true);
  };

  // Handle form submission success - closes form popup and opens master plan modal
  const handleFormSubmitSuccess = () => {
    setShowFormPopup(false);

    // Small delay for smooth transition
    setTimeout(() => {
      setShowMasterPlanModal(true);
      setIsLoading(true);
      document.body.style.overflow = 'hidden';
    }, 100);
  };

  // Handle form popup close
  const handleFormClose = () => {
    setShowFormPopup(false);
  };

  // Handle master plan modal close
  const closeMasterPlanModal = () => {
    setShowMasterPlanModal(false);
    document.body.style.overflow = 'auto';
  };


  const handleImageLoaded = () => {
    setIsLoading(false);
  };

  // Simple loading spinner component
  const LoadingSpinner = () => (
    <div className="flex justify-center items-center h-64">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-yellow-600"></div>
    </div>
  );

  // Handle click outside modal to close
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      closeMasterPlanModal();
    }
  };

  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <Heading level={2} className="text-center mb-8">Master Plan</Heading>
        
        <div className="flex justify-center">
          <div 
            className="relative cursor-pointer border-4 hover:border-yellow-200 transition-all duration-300 rounded-lg overflow-hidden shadow-sm hover:shadow-md"
            onClick={handleMasterPlanClick}
          >
            <img 
              src={masterPlanImage} 
              alt="Property Master Plan" 
              className="w-full max-w-2xl h-auto"
            />
            {/* Persistent button at bottom right */}
            <div className="absolute bottom-4 right-4">
              <span className="bg-yellow-600 hover:bg-yellow-700 text-white py-2 px-4 rounded-lg text-sm sm:text-base transition-colors duration-300">View Master Plan</span>
            </div>
          </div>
        </div>
      </div>

      {/* Form Details Popup - Shows first when user clicks on master plan */}
      <FormDetailsPopup
        isOpen={showFormPopup}
        onClose={handleFormClose}
        onSubmitSuccess={handleFormSubmitSuccess}
        planType="Master Plan"
      />

      {/* Master Plan Modal - Shows only after form submission */}
      {showMasterPlanModal && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
          onClick={handleBackdropClick}
        >
          <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] overflow-hidden">
            <div className="p-4 relative">
              {/* Header */}
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold text-gray-800">Master Plan</h2>
                <button
                  onClick={closeMasterPlanModal}
                  className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
                >
                  ×
                </button>
              </div>

              {/* Image container */}
              <div className="relative">
                {isLoading && <LoadingSpinner />}
                <img
                  src={masterPlanImage}
                  alt="Property Master Plan"
                  className={`w-full h-auto max-h-[60vh] object-contain ${isLoading ? 'hidden' : 'block'}`}
                  onLoad={handleImageLoaded}
                  onError={() => setIsLoading(false)}
                />
              </div>
            </div>

            {/* Footer */}
            <div className="p-4 border-t bg-gray-50 flex justify-between items-center">
              <div className="text-sm text-gray-600">
                <span className="font-medium">Vasudharini Nest - Master Plan</span>
              </div>
              <div className="flex space-x-3">
                <button
                  onClick={closeMasterPlanModal}
                  className="bg-gray-200 hover:bg-gray-300 text-gray-800 text-sm font-medium py-2 px-4 rounded transition-colors duration-200"
                >
                  Close
                </button>
                <a
                  href={masterPlanImage}
                  download="Vasudharini_Nest_Master_Plan.jpg"
                  className="bg-yellow-600 hover:bg-yellow-700 text-white text-sm font-medium py-2 px-4 rounded flex items-center transition-colors duration-200"
                >
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                  Download
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default MasterPlan;